import KSalesOrdersTable from "kinnect-front/Sales/SalesOrders/KSalesOrdersTable";
import { FetchesData } from "kinnect-mixins";
import {
	KAutocomplete,
	KForm,
	KTextField,
	KTextarea
} from "kinnect-general";
import { TransactionErrorType } from "kinnect-models";
import { VCard } from "vuetify/lib";
import { consoleWarn } from "vuetify/lib/util/console";
import { formatCurrency } from "kinnect-formatters";

export const defaultSalesOrdersTableProps = {
	hiddenCols: "actions",
	items: null
};

export default KForm.extend( {
	name: "KSalesOrderErrorForm",

	mixins: [ FetchesData ],

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "salesSalesOrders" } ]
		},

		salesOrderError: Object,

		salesOrdersTableProps: {
			default: () => defaultSalesOrdersTableProps,
			type: Object
		}
	},

	data: () => ( {
		errorTypes: [],
		formFields: {
			cost: null,
			error: null,
			errorTypes: [],
			salesOrders: []
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.salesOrderError );
		},

		formUrl() {
			const baseUrl = "sales/sales-orders/errors";

			return this.editing ? `${baseUrl}/${this.salesOrderError.id}` : baseUrl;
		},

		$_salesOrdersTableProps() {
			return {
				...defaultSalesOrdersTableProps,
				...this.salesOrdersTableProps
			};
		},

		selectedSalesOrders: {
			get() {
				if ( this.$_salesOrdersTableProps.items && this.formFields.salesOrders ) {
					return this.$_salesOrdersTableProps.items.filter(
						salesOrder => this.formFields.salesOrders.indexOf( salesOrder.id ) !== -1
					);
				}

				return [];
			},
			set( val ) {
				this.formFields.salesOrders = val ? val.map( item => item.id ) : null;
			}
		}
	},

	watch: {
		"$_salesOrdersTableProps.value": {
			handler( val ) {
				this.selectedSalesOrders = val;
			},
			immediate: true
		},

		salesOrderError: {
			handler( salesOrderError ) {
				if ( salesOrderError ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( salesOrderError.hasOwnProperty( key ) && key !== "salesOrders" ) {
							this.formFields[key] = salesOrderError[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchErrorTypes() {
			this.errorTypes = await TransactionErrorType.get();
		},

		async fetch() {
			await this.fetchErrorTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<VCard class="mb-4" outlined>
				<KSalesOrdersTable
					attrs={this.$_salesOrdersTableProps}
					vModel={this.selectedSalesOrders}
					validationName="sales order"
					validationRules="required"
				>
					<template slot="title">
						{this.$_salesOrdersTableProps.showSelect
							? "Select Sales Order(s) Associated with Error*"
							: "Sales Order(s) Associated with Error"
						}

					</template>
				</KSalesOrdersTable>
			</VCard>

			<KAutocomplete
				chips
				class="ml-blank-icon"
				deletableChips
				groupBy="category"
				itemText="name"
				itemValue="id"
				items={this.errorTypes}
				label="Error Type(s)*"
				loading={this.$wait.is( "get transaction error types" )}
				multiple
				required
				vModel={this.formFields.errorTypes}
				validationName="error type(s)"
				validationRules="required"
			></KAutocomplete>

			<KTextField
				hint={this.formFields.cost ? formatCurrency( this.formFields.cost ) : ""}
				label="Error Cost"
				onInput={val => this.formFields.cost = val ? parseFloat( val ) : null}
				persistentHint
				prependIcon="attach_money"
				type="number"
				validationName="error cost"
				validationRules="min_value:0"
				value={this.formFields.cost}
			></KTextField>

			<KTextarea
				label="Error Notes*"
				prependIcon="comment"
				required
				vModel={this.formFields.error}
				validationName="error notes"
				validationRules="required"
			></KTextarea>
		</KForm>;
	},

	created() {
		if ( !Array.isArray( this.salesOrdersTableProps.items ) ) {
			consoleWarn( "salesOrdersTableProps.items is required and must be an array", this );
		}
	}
} );
